
namespace Gamification.Gamification {
    export class ProdottiBadgeColumns {
        static columnsKey = 'Gamification.ProdottiBadge';
    }
}